import { Button, FormControl, MenuItem, Select, Stack, Typography } from "@mui/material";
import AwardCard from "components/datadisplay/cards/AwardCard";
import { AwardsCardLoader } from "components/loaders/AwardsLoaders";
import { PageHeading } from "components/typography/text";
import { useEffect, useState } from "react";
import useFetch from "services/hooks/useFetch";
import InfiniteScroll from "services/utils/ScrollOnload";
import { ApiUrls } from "services/utils/globalVariables";

export default function AwardsPage() {

    //*
    const [{ response, isLoading, error }, doFetch] = useFetch(ApiUrls.GetPrizeForUser, "get", true)
    const [loadCount, setLoadCount] = useState(1)

    const countToShow = 12

    useEffect(() => {
        handleApi()
    }, [])

    //When changing awards filter
    const handleApi = (e) => {
        if(e == undefined) {
            doFetch({orderby: "most_points"})
        } else {
            setLoadCount(1)
            doFetch({orderby: e.target.value})
        }
    }

    return (
        <Stack sx={{direction: "ltr !important"}}>
            <Stack spacing={1} sx={{mt: 3, padding: "0 16px"}}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" >
                    <PageHeading>جوایز</PageHeading>
                    <FormControl>
                        <Select
                            onChange={handleApi}
                            variant="standard"
                            defaultValue="most_points"
                            sx={{width: 120}}
                            className="filter-select"

                        >
                            <MenuItem sx={{display: "flex", justifyContent: "flex-end"}} value={"new"}>جدیدترین</MenuItem>
                            <MenuItem sx={{display: "flex", justifyContent: "flex-end"}} value={"most_points"}>پر امتیازترین</MenuItem>
                            <MenuItem sx={{display: "flex", justifyContent: "flex-end"}} value={"least_points"}>کم امتیازترین</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
                        {
                            isLoading ?
                            <>
                                <InfiniteScroll setCounter={setLoadCount}>
                                    <Stack sx={{width: "100%", mt: -2}} direction="row" justifyContent="space-between" flexWrap="wrap">
                                        {
                                            (response.Data.slice(0, (countToShow * loadCount))).map((val, i) => {
                                            return  <AwardCard key={i} data={val} />
                                            })
                                        }
                                        {
                                            response.Data.length == 0 &&
                                            <Stack sx={{width: "100%", py: 4}}>
                                                <Typography sx={{color: "grey", textAlign: "center", fontSize: "18px"}}>موردی وجود ندارد</Typography>
                                            </Stack>
                                        }
                                    </Stack>
                                </InfiniteScroll>
                            </> : <AwardsCardLoader />
                        }
            </Stack>
        </Stack>
    )
}